





























import { Component, Prop, Vue } from "vue-property-decorator";
import { isJpnAprilFool } from "../lambda/submodule/utils";
@Component
export default class OraaComponent extends Vue {
  @Prop() isJolyn!: boolean;
  readonly w = 792;
  readonly h = 792 * 1.5;
  readonly idxs = [...Array(10).keys()];
  isJpnAprilFool = isJpnAprilFool;
  currentIdx = 0;
  loopID = -1;
  get fillColor(): string {
    return this.isJolyn ? "pink" : "black";
  }
  get strokeColor(): string {
    return "white";
  }
  mounted(): void {
    this.oraora();
  }
  destroyed(): void {
    clearInterval(this.loopID);
  }
  oraora(): void {
    this.loopID = setInterval(() => {
      this.ora(this.currentIdx);
      this.currentIdx >= this.idxs.length - 1
        ? (this.currentIdx = 0)
        : this.currentIdx++;
    }, 100);
  }
  ora(i: number): void {
    const t = (this.$refs[`txt`] as SVGTextElement[])[i];
    if (!t) return;
    t.setAttribute("x", this.getRand(this.w + 20) - 20 + "");
    t.setAttribute("y", this.getRand(this.h + 50) - 50 + "");
    t.setAttribute("display", "block");
    t.classList.add("ora-anime");
  }
  endOra(t: SVGTextElement): void {
    t.classList.remove("ora-anime");
    t.setAttribute("display", "none");
  }
  getRand(n: number): number {
    return Math.random() * n;
  }
}
